<template>
  <Wrapper>
    <WrapperSubpages>
      <Grid>
        <Header>
          <SubPageNavigator
            v-bind="{
              home: true,
              isHeader: true,
            }"
          />
        </Header>
        <Nav />
      </Grid>
      <section>
        <Grid>
          <div class="grid-column forSubPages">
            <div class="title txt">
              <h2>Getting practical</h2>

              <p>
                Service design
                <br />Design management
                <br />Design operations
                <br />Design engineering
                <br />
                <br />
              </p>
            </div>
            <div class="contentForSubPages txt">
              <mq-layout mq="m">
                <img src="/static/img/getting-practical-01-m-633.svg" />
              </mq-layout>
              <mq-layout mq="s">
                <img src="/static/img/getting-practicalr-01-s-598.svg" />
              </mq-layout>
              <mq-layout :mq="['xs', '<xs']">
                <img src="/static/img/getting-practical-01-xs-275.svg" />
              </mq-layout>
              <p>
                Design is not a file created with your computer, neither a wall
                full of post-its. It’s the experience you deliver, when all sums
                up in a public release. It mirrors the capabilities an
                organization has to form value for someone else. Even with
                ambition and resources, a potential breakthrough is hard to
                craft.
              </p>
              <p>
                I work with my mind, hands and heart. Together we produce
                design, that will fit the needs of all parties involved. We find
                the best configuration possible and make sure it is produced in
                an outstanding quality.
              </p>

              <h3 class="specialSpacing">We can do this with:</h3>
            </div>
          </div>
        </Grid>
        <advancedTable></advancedTable>
      </section>
      <Grid>
        <div class="subpageEnd">
          <SubPageNavigator
            v-bind="{
              home: false,
              back: {
                number: 1,
                label: 'Act like a designer',
                path: 'act-like-a-designer',
              },
            }"
          />
          <a href="mailto:hello@humantechdesign.com" class="subpageEnd-mail">
            <span class="ArrowAsLink">hello@humantechdesign.com</span>
          </a>
        </div>
      </Grid>
    </WrapperSubpages>
  </Wrapper>
</template>
<script>
import Wrapper from "../Wrapper.vue";
import Grid from "../Grid.vue";
import Header from "../Header.vue";
import Nav from "../Nav.vue";
import WrapperSubpages from "./WrapperSubpages.vue";
import SubPageNavigator from "./SubPageNavigator.vue";
import Highlight from "./Highlight.vue";
import HighlightHook from "./HighlightHook.vue";
import AdvancedTable from "./AdvancedTable.vue";

export default {
  name: "ActLikeADesigner",
  components: {
    Wrapper,
    Grid,
    Header,
    WrapperSubpages,
    SubPageNavigator,
    Nav,
    Highlight,
    HighlightHook,
    AdvancedTable
  },
  data: function() {
    return {
      highlights: ["Innovation", "Qualification"]
    };
  }
};
</script>
<style scoped>
h3.specialSpacing {
  margin-top: calc(var(--LINE-HEIGHT) * 1);
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/GettingPractical.vue